import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { RunnerFlowsSearch } from './RunnerFlowsSearch';

const RunnerFlowsSearchBridge = react2angular(RunnerFlowsSearch, [
  'searchTerm'
]);

export default RunnerFlowsSearchBridge;
